export default __webpack_public_path__ + "img/Montserrat-SemiBold_262fb10.eot";